<template>
  <div class="order" :style="bannerFlag ? 'margin-top: 56px;':''">

    <div class="order-list w" style="min-height: calc(100vh - 125px);">

      <div class="search-box">

        <div class="search-box-left">

          <div class="search-item">
            <el-input size="mini" placeholder="服务单号" prefix-icon="el-icon-search" v-model="queryParams.servOrderNo"
              clearable @keyup.enter.native="querySearch" @clear="querySearch">
            </el-input>
          </div>

          <div class="search-item">
            <el-cascader v-model="queryParams.servCataId" :options="common.category" :props="optionProps" clearable
              filterable :show-all-levels="false" size="mini" placeholder="服务单类型" @change="changeServCataId">
            </el-cascader>
          </div>

          <div class="search-item">
            <el-select v-model="queryParams.dataType" size="mini" placeholder="数据类型">
              <el-option v-for="item in common.dict.get('biz_scan_type')" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="search-item">
            <el-select v-model="queryParams.desLevel" size="mini" placeholder="服务等级">
              <el-option v-for="item in common.dict.get('biz_des_level')" :key="item.value" :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>

          <div class="search-item">
            <el-switch v-model="queryParams.orderRushFlag" active-color="#00a5d5" inactive-color="#909399"
              active-value="1" inactive-value="0" active-text="加急" @change="changeOrderRushFlag">
            </el-switch>
          </div>
        </div>

        <div class="search-box-right">
          <y-button text="查询" classStyle="main-btn ml" @btnClick="querySearch"></y-button>
          <y-button text="重置" classStyle="main-btn ml" @btnClick="resetSearch"></y-button>
        </div>

      </div>

      <div v-loading="loading" element-loading-text="加载中..." element-loading-background="rgba(0, 0, 0, 0)"
        style="height: calc(100vh - 258px);">

        <div class="table-wrap" style="height: calc(100vh - 238px);">

          <el-table ref="dataTable" :data="orderList" tooltip-effect="dark" style="width: 100%; font-size: 13px;"
            size="small" height="250" :stripe="true" border v-if="orderList.length > 0" @mouseenter.native="mouseEnter"
            @mouseleave.native="mouseLeave">

            <el-table-column align="center" label="序号" width="60" show-overflow-tooltip>
              <template #default="scope">
                <span>{{scope.$index + 1}}</span>
              </template>
            </el-table-column>

            <el-table-column header-align="center" align="left" label="服务单号" width="210" show-overflow-tooltip>
              <template #default="scope">
                <div class="code-wrap">
                  {{scope.row.servOrderNo}}
                  <img src="/static/images/rush.png" v-if="scope.row.orderRushFlag === '1'">
                </div>
              </template>
            </el-table-column>

            <el-table-column label="服务单类型" align="center" width="170" show-overflow-tooltip>
              <template #default="scope">
                <serv-tag :code="scope.row.servCataId" />
              </template>
            </el-table-column>

            <el-table-column label="服务等级" align="center" width="80">
              <template #default="scope">
                <span v-if="!['1010410','1010510','1010698','1010699','1010700','4010110'].includes(scope.row.servCataId)">
                  <dict-tag dict="biz_des_level" :value="scope.row.desLevel"/>
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>

            <el-table-column prop="orderCount" label="数量" width="80" align="center">
            </el-table-column>

            <el-table-column label="金额" width="100" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{parseMoney(scope.row.orderAmount)}}
              </template>
            </el-table-column>

            <el-table-column prop="name" label="数据类型" align="center" width="155">
              <template #default="scope">
                <dict-tag dict="biz_scan_type" :value="scope.row.dataType" />
              </template>
            </el-table-column>
<!--
           <el-table-column prop="timeLimit" label="服务时长" width="80" align="center" show-overflow-tooltip>
              <template #default="scope">
                {{scope.row.timeLimit}} 分钟
              </template>
            </el-table-column>

            <el-table-column prop="orderRemark" label="备注信息" width="120" header-align="center" align="left"
              show-overflow-tooltip>
            </el-table-column> -->

            <el-table-column prop="demName" label="公司名称" width="150" header-align="center" align="center" show-overflow-tooltip>
              <template #default="scope">
                 {{hideName(scope.row.demName)}}
              </template>
            </el-table-column>

            <el-table-column label="操作" width="" align="center">
              <template #default="scope">
                  <s-button text="详情" @btnClick="clickDetail(scope.row)" :class="!scope.row.canReceive?'disBtn':''"
                  :disabled="!scope.row.canReceive"></s-button>
                  <s-button text="接单" @btnClick="clickConfirm(scope.row)" :class="!scope.row.canReceive?'disBtn':''"
                  :disabled="!scope.row.canReceive"></s-button>
              </template>
            </el-table-column>
          </el-table>

          <div class="no-data" v-if="noData">
            暂无数据
          </div>
          <div class="pagination-wrap" v-if="orderList.length">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="queryParams.pageNum"
              :page-size="queryParams.pageSize" layout="total,prev, pager, next, jumper" :total="total">
            </el-pagination>
          </div>
        </div>

      </div>

      <el-dialog :modal="false" :fullscreen="true" :modal-append-to-body="false" :visible.sync="dialogVisible"
        :show-close="false" class="dialog-wrap" :key="orderDetail.servOrderId">

        <div slot="title" class="dialog-wrap-header">

          <div class="dialog-header">
            {{orderDetail.servName}}<label> - </label>{{orderDetail.servOrderNo}}<label> -
            </label>{{orderDetail.demPatient}}
            <img src="/static/images/rush.png" v-if="orderDetail.orderRushFlag === '1'">
          </div>
          <div class="dialog-button">
            <y-button text="接单" classStyle="main-btn" @btnClick="clickConfirm(orderDetail)"></y-button>
            <y-button text="返回" classStyle="main-btn" @btnClick="clickCloseDetail"></y-button>
          </div>

        </div>

        <div class="dialog-wrap-content">

          <el-tabs v-model="activeName" type="card" @tab-click="handleTabClick">

            <el-tab-pane name="info">

              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-data-analysis"></i>
                <span>服务单详情</span>
              </span>

              <div class="tabs-pane-content">
                <!-- <detail-order :orderDetail="orderDetail"></detail-order> -->
                <detail-order v-if="!['4010110','3010130','4010120'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></detail-order>
                <orth-order v-if="['3010130'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></orth-order>
                <active-order v-if="['4010110','4010120'].includes(orderDetail.servCataId)" :orderDetail="orderDetail"></active-order>
              </div>

            </el-tab-pane>

            <el-tab-pane name="data">

              <span slot="label" class="tabs-pane-title">
                <i class="el-icon-film"></i>
                <span>数据详情</span>
              </span>

              <div class="tabs-pane-content">
                <detail-down :orderDetail="orderDetail" :isDown="false"></detail-down>
              </div>

            </el-tab-pane>

          </el-tabs>

        </div>

      </el-dialog>
    </div>
    <Customer class="customerSer"></Customer>
  </div>
</template>
<script>
  import YShelf from '/components/YShelf'
  import YButton from '/components/YButton'
  import SButton from '/components/SButton'
  import DictTag from '/components/DictTag'
  import ServTag from '/components/ServTag'
  import DetailOrder from './detailOrder';
  import DetailDown from './detailDown';
  import Customer from '../Order/components/customerSer';
  import OrthOrder from './orthodonticsOrder/orthodonticsOrderDetail';
  import ActiveOrder from './activeModification/activeDetail';
  import {
    getStore
  } from '/utils/storage'
  import {
    mapState
  } from 'vuex'
  import orderList from "/assets/config/order/orderList.js";

  let that;
  export default {
    data() {
      return {
        roll_timer: null,
        refresh_timer: null,
        rollPause: false,
        rollBottom: 0,
        bannerFlag: false,
        loading: true,
        orderList: [],
        total: 0,
        queryParams: {
          servOrderNo: '',
          servCataId: [],
          dataType: '',
          orderRushFlag: '',
          desLevel:'',
          pageNum: 1,
          pageSize: 15,
        },
        noData: false,
        orderDetail: {},
        dialogVisible: false,
        confirmVisible: false,
        activeName: 'info',
        optionProps: {
          value: 'servId',
          label: 'servName',
          children: 'children',
          expandTrigger: 'hover'
        },
        timerId:null,
      }
    },
    created(){
      this.timerId = setInterval(() => {
        this.fetchData();
      }, 1 * 60 * 1000);
      document.title = "医小智 - 服务单大厅"
      this.userId = getStore('userId');
      this.$store.commit('common/recordNav', {
        navIndex: 1,
        navSubIndex: 0
      })
    },
    beforeDestroy() {
      // 清除时间
      clearInterval(this.timerId);
    },
    mounted() {
      this.navFixed();
      window.addEventListener('scroll', this.navFixed);
      window.addEventListener('resize', this.navFixed);
      that = this;
      this.loadDataList();
      this.autoRefresh();
    },
    beforeDestroy() {
      this.autoRoll(true)
    },
    // destroyed() {
    //   this.autoRoll(true)
    // },
    computed: {
      ...mapState(['common', 'user'])
    },
    components: {
      YShelf,
      YButton,
      SButton,
      DictTag,
      ServTag,
      DetailOrder,
      DetailDown,
      Customer,
      OrthOrder,
      ActiveOrder
    },
    methods: {
      loadDataList() {
        this.$api.get({
          url: '/biz/orderServ/list',
          data: this.queryParams
        }).then(res => {
          if(res.data&&Array.isArray(res.data)&&res.data.length>0){
            this.orderList = res.data.sort((a,b) =>{
              const aTime = new Date(a.payTime).getTime();
              const bTime = new Date(b.payTime).getTime();
              return aTime - bTime;
            })
          }else{
            this.orderList = res.data
          }
          this.total = res.total;
          if (this.orderList.length > 0) {
            this.noData = false;
            var tableObj = this.$refs.dataTable;
            if (tableObj && tableObj.bodyWrapper) {
              tableObj.bodyWrapper.scrollTop = 0;
            }

            if (this.orderList.length > 15) {
              setTimeout(function() {
                that.autoRoll();
              }, 3000);
            }

          } else {
            this.noData = true;
          }
          this.loading = false;

        })

      },
      changeServCataId() {
        this.queryParams.servCataId = this.queryParams.servCataId[1];
      },
      changeOrderRushFlag() {
        if (this.queryParams.orderRushFlag === '0') {
          this.queryParams.orderRushFlag = '';
        }
        this.loadDataList()
      },
      querySearch() {
        this.loadDataList();
      },
      resetSearch() {
        this.queryParams.servOrderNo = '';
        this.queryParams.servCataId = [];
        this.queryParams.dataType = '';
        this.queryParams.desLevel = '';
        this.queryParams.orderRushFlag = '';
        this.loadDataList();
      },
      clickDetail(row) {

        this.rollPause = true;
        this.autoRoll(true);
        this.loading = true

        this.$api.get({
          url: '/biz/orderServ/detail/' + row.servOrderId
        }).then(res => {
          console.log('detail',res)
          this.loading = false
          this.dialogVisible = true;
          let detailData = {};
          for (var key in res.data) {
            if (key === "posSingle") {
              detailData.posSingleList = res.data.posSingle.split(',');
            } else if (key === "posBridge") {
              detailData.posBridgeList = res.data.posBridge.split(',');
            } else {
              detailData[key] = res.data[key];
            }
          }
          this.orderDetail = detailData;
          this.orderDetail.servName = this.common.serv.get(this.orderDetail.servCataId).servName;
        })
      },
      clickCloseDetail() {
        this.dialogVisible = false;
        this.rollPause = false;
        this.autoRoll();
        this.orderDetail = {};
      },
      handleTabClick(tab, event) {
        // console.log(tab, event);
      },
      // 判断接单等级是否可接单
      clickConfirm(row, close) {
        this.$api.get({
          url: '/biz/orderServ/detail/' + row.servOrderId
        }).then(res => {
          let status = res.data.orderStatus;
          if(status!=='10'){
            this.$message({
              type:'error',
              message:'当前订单已被接单，请选择其他订单'
            })
            return false;
          }
          this.rollPause = true;
          this.autoRoll(true)
          if((parseInt(this.user.desLevel)>=parseInt(row.desLevel))&&(row.servCataId!=='1010410'&&row.servCataId!=='1010510')){
            this.acceptOrder(row, close)
          }else if((row.servCataId=='1010410'||row.servCataId=='1010510')&&(parseInt(this.user.desLevel)>parseInt('1'))){
            this.acceptOrder(row, close)
          }else{
            this.$message({
              type:'error',
              message:'设计师级别与当前服务单服务等级不符'
            })
            return false;
          }
        })
      },
      // 调用接单接口
      acceptOrder(row){
        this.$confirm('确定接取服务单【' + row.servOrderNo + '】?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          center: true
        }).then(() => {
          this.loading = true
          this.$api.get({
            url: '/biz/orderServ/des/take/' + row.servOrderId
          }).then(res => {
            this.loading = false
            this.$message({
              type: 'success',
              message: '接单成功!'
            });
            if (close) {
              this.clickCloseDetail()
            }
            this.rollPause = false;
            this.loadDataList();
          })
        }).catch(() => {
          this.rollPause = false;
          this.autoRoll();
        });
      },
      // 设置自动滚动
      autoRoll(stop) {
        return false
        if (stop) {
          clearInterval(this.roll_timer);
          this.roll_timer = null;
          return
        }
        var tableObj = this.$refs.dataTable;
        var tableDiv = tableObj.bodyWrapper;
        if (tableDiv.clientHeight + 15 >= tableDiv.scrollHeight) {
          this.autoRoll(true);
          return
        }
        // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果
        this.roll_timer = setInterval(() => {

          // 元素自增距离顶部像素
          tableDiv.scrollTop += 1;
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (tableDiv.clientHeight + tableDiv.scrollTop == tableDiv.scrollHeight) {
            // this.autoRefresh();
            // 重置table距离顶部距离
            tableDiv.scrollTop = 0;

          }

        }, 150)
      },
      autoRefresh(stop) {
        if (stop) {
          clearInterval(this.refresh_timer);
          this.refresh_timer = null;
          return
        }
        this.refresh_timer = setInterval(() => {
          that.loadDataList()
        }, 3000)
      },
      // 鼠标进入
      mouseEnter() {
        // 鼠标进入停止滚动
        if (this.orderList.length > 15) {
          this.autoRoll(true)
        }
      },
      // 鼠标离开
      mouseLeave() {
        // 开启
        if (this.rollPause) {
          return;
        }
        if (this.orderList.length > 15) {
          this.autoRoll()
        }
      },
      // 控制顶部
      navFixed() {
        if (this.$route.path === '/order/mall') {
          var st = document.documentElement.scrollTop || document.body.scrollTop
          st >= 60 ? this.bannerFlag = true : this.bannerFlag = false
        } else {
          return
        }
      },
      async fetchData(){
        try{
          this.loadDataList()
        }catch(e){
          console.error('Error fetching data:', error);
        }
      },
      //隐藏工厂名称
      hideName(str){
        let name = '***'
        return str.charAt(0)+ name + str.charAt(str.length - 1)
      },
      // 切换分页
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.loadDataList()
      },
    }
  }
</script>
<style lang="scss">
  @import "../../assets/style/mixin";

  .order {
    display: flex;
    flex-direction: column;
    perspective: 3000px;
    position: relative;
    z-index: 19;
    margin: 10px auto;
  }

  .search-box {
    position: relative;
    overflow: hidden;
    // background: #f3f3f3;
    // background: -webkit-linear-gradient(#fbfbfb, #ececec);
    // background: linear-gradient(#fbfbfb, #ececec);
    position: relative;
    margin: 10px;
    padding: 10px;
    // border-bottom: 1px solid #d4d4d4;
    // border-radius: 8px 8px 0 0;
    // border-color: rgba(0, 0, 0, .14);
    // box-shadow: rgba(0, 0, 0, .06) 0 1px 7px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #626262;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    z-index: 10;

    .floor-btn {
      display: inline-block;
      height: 32px;
      line-height: 32px;
      border: 1px solid #e1e1e1;
      padding: 0 15px;
      color: #666;
      font-size: 14px;
      border-radius: 5px;
      background: -webkit-linear-gradient(#fbfbfb, #ececec);
      background: linear-gradient(#fbfbfb, #ececec);
      background-image: -webkit-gradient(linear, left top, left bottom, from(#fbfbfb), to(#ececec));
      background-image: linear-gradient(180deg, #fbfbfb, #ececec);
      border: 1px solid red;
    }

    .search-box-left {
      display: flex;
      flex-direction: row;
    }

    .search-item {
      margin-right: 10px;

      &.mt {
        margin-top: 1px;
      }
    }

    .search-box-right {
      display: flex;
      flex-direction: row;
    }

  }

  .order-list {
    border-radius: 8px;
    position: relative;
    z-index: 20;
    background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .table-wrap {
    padding: 0 10px;
    display: flex;
    flex-direction: column;
  }

  .code-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
      width: 20px;
      height: 20px;
    }
  }

  .dialog-wrap {
    width: 1220px;
    margin: 0 auto;
  }

  .dialog-wrap-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    height: 45px;
  }

  .dialog-header {
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 32px;
    font-weight: 500;

    label {
      margin: 0 10px;
    }

    img {
      width: 26px;
      height: 26px;
      margin-left: 10px;
      margin-top: -5px;
    }
  }

  .dialog-button {
    // border: 1px solid black;
  }

  .dialog-wrap-content {
    margin: 0 10px;
    margin-top: -30px;
  }

  .tabs-pane-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: normal;

    span {
      margin-left: 5px;
    }

    i {
      font-size: 16px;
    }
  }

  .el-tabs__item.is-active {
    color: #00a5d5;
  }

  .el-tabs__active-bar {
    background-color: #00a5d5;
  }

  .el-tabs__item:hover {
    color: #00a5d5;
    cursor: pointer;
  }

  .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
    border-bottom-color: #00a5d5;
  }

  .tabs-pane-content {
    height: calc(100vh - 280px);
    border-bottom: 1px solid #E4E7ED;
    padding: 5px 20px 20px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .el-dialog {
    border-radius: 8px;
    background: #f7f7f7;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  }

  .el-table__body-wrapper::-webkit-scrollbar {
    /*width: 0;宽度为0隐藏*/
    width: 0px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 2px;
    height: 50px;
    background: #eee;
  }

  .el-table__body-wrapper::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 2px;
    background: rgba(0, 0, 0, 0.4);
  }

  .el-switch__label.is-active {
    color: #00a5d5;
  }

  .el-switch__label {
    -webkit-transition: .2s;
    transition: .2s;
    font-size: 13px;
    vertical-align: middle;
    color: #909399;
  }

  .el-switch__label * {
    line-height: 1;
    font-size: 13px;
    display: inline-block;
  }

  .el-button--primary {
    color: #FFF;
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .el-button--primary:hover {
    color: #FFF;
    background-color: #6c8cd4;
    background-image: -webkit-linear-gradient(top, #6c8cd4, #00a5d5);
    background-image: linear-gradient(180deg, #6c8cd4, #00a5d5);
  }

  .pagination-wrap {
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 5px 15px;
  }

  .el-dialog__header {
    padding: 10px 20px 10px;
  }

  .el-pager li.active {
    color: #00a5d5;
    cursor: default;
  }

  .el-pager li:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-left:hover {
    color: #00a5d5;
  }

  .el-icon-arrow-right:hover {
    color: #00a5d5;
  }

  .el-pagination span:not([class*=suffix]) {
    display: inline-block;
    font-size: 12px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    vertical-align: top;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #00a5d5;
    border-color: #00a5d5;
  }

  .no-data {
    min-height: 527px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .row-bg{
    color: rgba($color: #bdc3c7, $alpha: 1.0);
    background-color: rgba(#ccc,0.3) !important;
  }
  .disBtn{
    color: #ccc !important;
    cursor: not-allowed !important;
  }
</style>



// WEBPACK FOOTER //
// orderMall.vue?5db928c7